const routerSourceAndDestinationType = {
  DEPOT: 'DEPOT',
  CONSIGNEE: 'CONSIGNEE',
  VENDOR_DEPOT: 'VENDOR_DEPOT',
  PORT: 'PORT',
  NO_MASTER_ENTITY: 'NO_MASTER_ENTITY',
  GATE: 'GATE',
};

const routeMasterStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
};

const routerMasterStatusMapping = [
  {
    id: routeMasterStatus.ACTIVE,
    label: 'Active',
  },
  {
    id: routeMasterStatus.INACTIVE,
    label: 'Inactive',
  },
];

module.exports = {
  routerSourceAndDestinationType,
  routerMasterStatusMapping,
  routeMasterStatus,
};
